
import { defineComponent } from 'vue';
import VModal from './componets/VModal.vue';
export default defineComponent({
    name: 'App',
    components: {
        VModal,
    }
});
